export var ActivityStatusStatus;
(function (ActivityStatusStatus) {
    ActivityStatusStatus["UNKNOWN"] = "UNKNOWN";
    ActivityStatusStatus["ACTIVE"] = "ACTIVE";
    ActivityStatusStatus["MUTED"] = "MUTED";
})(ActivityStatusStatus || (ActivityStatusStatus = {}));
export var PrivacyStatusStatus;
(function (PrivacyStatusStatus) {
    PrivacyStatusStatus["UNKNOWN"] = "UNKNOWN";
    PrivacyStatusStatus["PRIVATE"] = "PRIVATE";
    PrivacyStatusStatus["PUBLIC"] = "PUBLIC";
})(PrivacyStatusStatus || (PrivacyStatusStatus = {}));
export var Status;
(function (Status) {
    Status["UNKNOWN"] = "UNKNOWN";
    Status["PENDING"] = "PENDING";
    Status["APPROVED"] = "APPROVED";
    Status["BLOCKED"] = "BLOCKED";
    Status["OFFLINE"] = "OFFLINE";
})(Status || (Status = {}));
export var ModerationStatusStatus;
(function (ModerationStatusStatus) {
    ModerationStatusStatus["UNKNOWN"] = "UNKNOWN";
    ModerationStatusStatus["APPROVED"] = "APPROVED";
    ModerationStatusStatus["REJECTED"] = "REJECTED";
})(ModerationStatusStatus || (ModerationStatusStatus = {}));
export var FeedType;
(function (FeedType) {
    FeedType["UNKNOWN_FEED_TYPE"] = "UNKNOWN_FEED_TYPE";
    FeedType["ALL_POSTS"] = "ALL_POSTS";
    FeedType["CATEGORY"] = "CATEGORY";
    FeedType["TAG"] = "TAG";
    FeedType["HASHTAG"] = "HASHTAG";
    FeedType["ARCHIVE"] = "ARCHIVE";
    FeedType["POST_LIST_WIDGET"] = "POST_LIST_WIDGET";
})(FeedType || (FeedType = {}));
//# sourceMappingURL=types.impl.js.map